import React, { Component } from 'react';
import { number, string, bool, array, func } from 'prop-types';

import { FilterView } from '../index';

class Filter extends Component {
  static propTypes = {
    items: array.isRequired,
    onFilterChange: func.isRequired,
    name: string.isRequired,
    className: string,
    search: bool,
    activeParamsNumber: number,
    mobileModal: bool,
  };

  static defaultProps = {
    items: [],
    onFilterChange() {},
    search: false,
    activeParamsNumber: 0,
    className: '',
    mobileModal: false,
  };

  state = {
    open: false,
    data: [],
    isMobile: false,
  };

  componentDidMount() {
    this.setDataFromTemplate(this.props.items);
    document.addEventListener('mousedown', this.closeOnDocumentClick);
    this.updateMobileState();
    window.addEventListener('resize', this.updateMobileState);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!this.state.open && nextProps.activeParamsNumber === this.props.activeParamsNumber) {
      this.setDataFromTemplate(nextProps.items);
    }
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.closeOnDocumentClick);
    window.removeEventListener('resize', this.updateMobileState);
  }

  updateMobileState = () => {
    this.setState({ isMobile: window.innerWidth <= 767 });
  };

  setDataFromTemplate = items => {
    this.setState(() => ({ data: this.mapItems(items) }));
  };

  mapItems = items =>
    items.map(({ id, title, count, subParams = [], checked = false }) => ({
      id,
      title,
      count,
      subParams: this.mapItems(subParams),
      checked,
    }));

  updateItem = (id, mapValue = () => {}, cb = () => {}) => {
    this.setState(
      prevState => ({
        data: this.findSelectedItems(id, mapValue, prevState.data),
      }),
      cb,
    );
  };

  findSelectedItems = (id, mapValue, items = []) => {
    return items.map(item => {
      const { id: itemId } = item;

      // намеренно не строгое сравнение
      if (id == itemId) {
        return mapValue(item) || {};
      }

      if (item.subParams && item.subParams.length > 0) {
        item.subParams = this.findSelectedItems(id, mapValue, item.subParams);
      }

      return item;
    });
  };

  uncheckAll = () => {
    this.props.onFilterReset();
    const { data: params } = this.state;
    const data = params.map(param => {
      const { subParams = [] } = param;
      param.checked = false;

      if (subParams.length > 0) {
        param.subParams = subParams.map(subParam => {
          subParam.checked = false;
          return subParam;
        });
      }

      return param;
    });

    this.setState(() => ({ open: false, data }));
  };

  clearMobile = () => {
    this.props.onFilterReset();
    this.setState({ open: false, data: this.mapItems(this.props.items).map(item => ({ ...item, checked: false })) });
  };

  checkOnParentIfNeeded = id => {
    this.updateItem(id, item => ({
      ...item,
      checked: item.subParams.every(({ checked }) => checked),
    }));
  };

  onItemChange = (id, e, hasSubItems) => {
    const checked = e.target.checked;
    const notifyParentHook = () => {
      if (!this.props.mobileModal || !this.state.isMobile) {
        this.props.onFilterChange(this.state.data);
      }
    };

    this.updateItem(id, item => ({ ...item, checked }), notifyParentHook);

    if (hasSubItems) {
      this.updateItem(
        id,
        item => ({
          ...item,
          subParams: item.subParams.map(subItem => ({
            ...subItem,
            checked,
          })),
        }),
        notifyParentHook,
      );
    }
  };

  closeOnDocumentClick = e => {
    if (this.props.mobileModal && this.state.isMobile) return;
    if (this.$ref && !this.$ref.contains(e.target)) {
      this.setState(() => ({ open: false }));
    }
  };

  handleRef = el => (this.$ref = el);

  toggle = () => {
    this.setState(prevState => ({
      open: !prevState.open,
      data: this.props.mobileModal && this.state.isMobile
        ? this.mapItems(this.props.items)
        : prevState.data,
    }));
  };

  applyMobile = () => {
    this.props.onFilterChange(this.state.data);
    this.setState({ open: false });
  };

  render() {
    const { name, defaultLabel, search, activeParamsNumber, className } = this.props;
    const { open, data } = this.state;
    const propsData = { ...this.state, ...this.props };
    return (
      <FilterView
        data={propsData}
        handleRef={this.handleRef}
        toggle={this.toggle}
        uncheckAll={this.uncheckAll}
        clearMobile={this.clearMobile}
        applyMobile={this.applyMobile}
        onItemChange={this.onItemChange}
        checkOnParentIfNeeded={this.checkOnParentIfNeeded}
      />
    );
  }
}

export default Filter;
